<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="490px"
      :before-close="handleClose"
      top="200px"
      :close-on-click-modal="false"
      :lock-scroll="true"
    >
      <div class="shadeContain" v-if="rflag">
        <div class="blackWeight">账号注册</div>
        <div class="defineInput">
          <img src="../image/juese.png" alt="" />
          <select v-model="ruleForm.type" placeholder="请选择注册角色">
            <option disabled selected value style="display: none; color: #9999">
              请选择注册类型
            </option>
            <option label="学生" value="学生"></option>
            <option value="教师" label="教师"></option>
          </select>
        </div>
        <div class="defineInput">
          <img src="../image/name.png" alt="" /><input
            type="text"
            v-model.trim="ruleForm.name"
            placeholder="请输入姓名"
          />
        </div>
        <div class="defineInput">
          <img src="../image/phone.png" alt="" /><input
            type="text"
            v-model.trim="ruleForm.phone"
            placeholder="请输入手机号"
          />
        </div>
        <div class="defineInput">
          <img src="../image/mima.png" alt="" /><input
            type="text"
            v-model.trim="ruleForm.password"
            placeholder="请输入密码"
          />
        </div>

        <div
          class="logininfo"
          @click="!disable ? zhuce() : ''"
          :disabled="disable"
        >
          注册
        </div>
        <div class="exituser">
          已有账号?<span @click="loginpop">去登录</span>
        </div>
      </div>
      <div class="shadeContain" v-if="lflag">
        <div class="blackWeight">登录</div>
        <div class="defineInput">
          <img src="../image/phone.png" alt="" /><input
            type="text"
            v-model.trim="ruleForm.phone"
            placeholder="请输入手机号"
          />
        </div>
        <div class="defineInput">
          <img src="../image/mima.png" alt="" /><input
            type="text"
            v-model.trim="ruleForm.password"
            placeholder="请输入密码"
          />
        </div>

        <div class="logininfo" @click="denglu">登录</div>
        <div class="exituser">
          还没有账号?<span @click="regestpop">去注册</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "RegestLogin",
  data() {
    return {
      ruleForm: {}, //表单
      rflag: false, //注册
      lflag: false, //登录
      dialogVisible: false, //弹窗是否显示
      disable: false, //注册按钮禁止点击
    };
  },
  props: {
    regest_flag: {},
    login_flag: {},
  },
  mounted() {
    this.rflag = this.regest_flag;
    this.lflag = this.login_flag;
    if (this.rflag) {
      this.lflag = false;
      this.ruleForm = {
        role:"",
        name: "",
        phone: "",
        type: "",
        password: "",
        state: "未审批",
        regtime: "",
      };
    } else if (this.lflag) {
      this.rflag = false;
      this.ruleForm = {
        password: "",
        phone: "",
      };
    }
    this.dialogVisible = true;
  },

  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.$emit("handleClose", false);
    },
    // 注册
    zhuce() {
      if (
        this.ruleForm.name == "" ||
        this.ruleForm.phone == "" ||
        this.ruleForm.password == "" ||
        this.ruleForm.type == ""
      ) {
        this.$message({
          type: "warning",
          message: "各项都不能为空，必须填写",
        });
        return;
      }
      let pattern1 = /^1[34578]\d{9}$/;
      if (!pattern1.test(this.ruleForm.phone)) {
        this.$message({
          type: "warning",
          message: "手机号格式不正确",
        });
        return;
      }
      if (
        this.ruleForm.password.length < 6 ||
        !/^[0-9A-Za-z]{6,18}$/.test(this.ruleForm.password)
      ) {
        this.$message({
          type: "warning",
          message: "密码有数字或字母组成，至少6位",
        });
        return;
      }

      // console.log(this.ruleForm);
      this.$axios({
        methods: "get",
        url:
          "Data?uid=39&layer=userinfo&operation=query&queryfields=phone&queryvalues=" +
          this.ruleForm.phone,
      }).then((res) => {
        if (res.data.size > 0) {
          this.$message({
            type: "warning",
            message: "手机号重复",
          });
        } else {
          this.ruleForm.state = "未审批";
          this.ruleForm.role = "normal";
          this.ruleForm.regtime = this.OperateTime(new Date());
          console.log(this.ruleForm);
          let form = encodeURIComponent(JSON.stringify(this.ruleForm));
          var fd1 = new FormData();
          fd1.append("jsondata", form);
          this.disable = true;
          this.$axios({
            method: "post",
            url: `Data?uid=39&layer=userinfo&operation=add`,
            data: fd1,
          }).then((res) => {
            if (res.data.state) {
              this.$message({
                message: "注册成功",
                type: "success",
              });
              setTimeout(() => {
                this.disable = false;
              }, 2000);
            } else {
              this.$message({
                message: "注册失败",
                type: "error",
              });
            }
            this.handleClose();
          });
        }
      });
    },
    // 登录
    denglu() {
      if (this.ruleForm.phone == "" || this.ruleForm.password == "") {
        this.$message({
          type: "warning",
          message: "各项都需要填写",
        });
        return;
      }

      this.$axios({
        method: "get",
        url: `Data?uid=39&layer=userinfo&operation=query&queryfields=phone,password&queryvalues=${this.ruleForm.phone},${this.ruleForm.password}`,
      }).then((res) => {
        if (res.data.size == "0") {
          this.$message.error("手机号或密码错误，请重新填写");
        } else if (res.data.size == "1") {
          if (res.data.data[0].state != "已通过") {
            this.$message({
              // title:"警告",
              message: "该账号不可用,禁止登录,请联系管理员",
              type: "warning",
            });
            return;
          }
          this.$message({
            message: "登录成功",
            type: "success",
          });
          this.handleClose();
          this.$router.push({ path: "/homePage" });
          this.$store.state.WebLoginuser = res.data.data[0];
        }
      });
    },
    // 去登录
    loginpop() {
      this.rflag = false;
      this.lflag = true;
      this.ruleForm = {
        password: "",
        phone: "",
      };
    },
    // 去注册
    regestpop() {
      this.lflag = false;
      this.rflag = true;
      this.ruleForm = {
        name: "",
        phone: "",
        type: "",
        password: "",
      };
    },
  // 当前日期
    OperateTime(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var hour = date.getHours();
      hour = hour < 10 ? "0" + hour : hour;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var sencond = date.getSeconds();
      sencond = sencond < 10 ? "0" + sencond : sencond;
      var time =
        y + "-" + m + "-" + d + " " + hour + ":" + minute + ":" + sencond;
      return time;
    },
  },
};
</script>
<style  scoped>
input,
select,
option {
  outline: none;
  border: none;
  padding-left: 45px;
  width: 380px;
  height: 50px;
  background: #ffffff;
  border: 1px solid #c2cad8;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 16px;
}
option {
  margin: 20px 0;
}
input::-webkit-input-placeholder {
  font-size: 16px;
  color: #333;
}
.defineInput {
  position: relative;
  margin-bottom: 30px;
}

.defineInput img {
  display: inline-block;
  position: absolute;
  top: 15px;
  left: 15px;
  /* width: 100%; */
  height: 22px;
}

.defineInput input:focus {
  border: 1px solid #0d6cba;
  /* box-shadow: 0 0 10px 0 rgba(114, 113, 255, 0.34); */
}

.exituser {
  text-align: center;
  margin-top: 25px;
  font-size: 14px;
}
.exituser span {
  cursor: pointer;
  color: #3178d2;
}
.logininfo {
  margin-top: 44px;
  width: 380px;
  height: 54px;
  line-height: 54px;
  background: #3178d2;
  border-radius: 4px;
  color: #fff;
  text-align: center;
  font-size: 20px;
  cursor: pointer;
}
div /deep/ .el-dialog {
  height: auto;
}
.blackWeight {
  height: 24px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  margin-bottom: 33px;
  margin-top: 20px;
}
div /deep/ .el-form-item {
  width: 380px;
  margin-bottom: 30px;
}
div /deep/ .el-dialog__headerbtn .el-dialog__close {
  background: #eee;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  font-size: 26px;
}
.shadeContain {
  margin: 0 30px;
}
</style>